/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VariableValue,
    VariableValueFromJSON,
    VariableValueFromJSONTyped,
    VariableValueToJSON,
} from './';

/**
 * 
 * @export
 * @interface Variation
 */
export interface Variation {
    /**
     * System generated Unique ID of the Variation
     * @type {number}
     * @memberof Variation
     */
    readonly id: number;
    /**
     * The URN for the Variation
     * @type {string}
     * @memberof Variation
     */
    readonly urn: string;
    /**
     * User-facing Unique identifier of the Variation
     * @type {string}
     * @memberof Variation
     */
    key: string;
    /**
     * User-facing name of the Variation
     * @type {string}
     * @memberof Variation
     */
    name: string;
    /**
     * Additional context of the Variation
     * @type {string}
     * @memberof Variation
     */
    description?: string;
    /**
     * Map of flag variables that include variable key and value
     * @type {{ [key: string]: VariableValue; }}
     * @memberof Variation
     */
    variables?: { [key: string]: VariableValue; };
    /**
     * The Key of the Flag this Variation belongs to
     * @type {string}
     * @memberof Variation
     */
    flag_key: string;
    /**
     * Map of rule/ruleset count associated with the variation in each environment that includes environment key as key and count as value
     * @type {{ [key: string]: number; }}
     * @memberof Variation
     */
    readonly environment_usage_count?: { [key: string]: number; };
    /**
     * Timestamp when the Variation is created
     * @type {Date}
     * @memberof Variation
     */
    readonly created_time: Date;
    /**
     * Timestamp when the Variation is updated
     * @type {Date}
     * @memberof Variation
     */
    readonly updated_time: Date;
    /**
     * Indicates if the Variation is archived or not
     * @type {boolean}
     * @memberof Variation
     */
    archived?: boolean;
    /**
     * Indicates if the Variation is enabled or not
     * @type {boolean}
     * @memberof Variation
     */
    readonly enabled?: boolean;
    /**
     * Indicates if the Variation is in use by a rule or a ruleset
     * @type {boolean}
     * @memberof Variation
     */
    readonly in_use?: boolean;
    /**
     * Link to self
     * @type {string}
     * @memberof Variation
     */
    readonly url: string;
    /**
     * Link to flag url of this variation
     * @type {string}
     * @memberof Variation
     */
    readonly fetch_flag_url?: string;
    /**
     * Link to update this Variation
     * @type {string}
     * @memberof Variation
     */
    readonly update_url?: string;
    /**
     * Link to archive this Variation
     * @type {string}
     * @memberof Variation
     */
    readonly archive_url?: string;
    /**
     * Link to unarchive this Variation
     * @type {string}
     * @memberof Variation
     */
    readonly unarchive_url?: string;
    /**
     * Link to delete this Variation
     * @type {string}
     * @memberof Variation
     */
    readonly delete_url?: string;
    /**
     * Revision number for tracking changes
     * @type {number}
     * @memberof Variation
     */
    readonly revision?: number;
    /**
     * Granular permission role
     * @type {string}
     * @memberof Variation
     */
    readonly role?: string;
}

export function VariationFromJSON(json: any): Variation {
    return VariationFromJSONTyped(json, false);
}

export function VariationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Variation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'urn': json['urn'],
        'key': json['key'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'variables': !exists(json, 'variables') ? undefined : (mapValues(json['variables'], VariableValueFromJSON)),
        'flag_key': json['flag_key'],
        'environment_usage_count': !exists(json, 'environment_usage_count') ? undefined : json['environment_usage_count'],
        'created_time': (new Date(json['created_time'])),
        'updated_time': (new Date(json['updated_time'])),
        'archived': !exists(json, 'archived') ? undefined : json['archived'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'in_use': !exists(json, 'in_use') ? undefined : json['in_use'],
        'url': json['url'],
        'fetch_flag_url': !exists(json, 'fetch_flag_url') ? undefined : json['fetch_flag_url'],
        'update_url': !exists(json, 'update_url') ? undefined : json['update_url'],
        'archive_url': !exists(json, 'archive_url') ? undefined : json['archive_url'],
        'unarchive_url': !exists(json, 'unarchive_url') ? undefined : json['unarchive_url'],
        'delete_url': !exists(json, 'delete_url') ? undefined : json['delete_url'],
        'revision': !exists(json, 'revision') ? undefined : json['revision'],
        'role': !exists(json, 'role') ? undefined : json['role'],
    };
}

export function VariationToJSON(value?: Variation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'name': value.name,
        'description': value.description,
        'variables': value.variables === undefined ? undefined : (mapValues(value.variables, VariableValueToJSON)),
        'flag_key': value.flag_key,
        'archived': value.archived,
    };
}


